module.exports = __webpack_public_path__ + "media/images/illustration_12-965c7a904435dfb879d56af4a7af48c1.png";